// @greenlight-spec: 57-screenshot-walkthroughs.md, 28-it-dashboard-ui.md
import { walkthroughs, type Walkthrough } from './index';

/**
 * The catalog connection profiles whose register-stepper Set up step shows a
 * vendor-console walkthrough, keyed `<catalog_key>/<profile id>`. An entry
 * whose Set up text is enough on its own has no row.
 */
export const INTEGRATION_WALKTHROUGHS: Readonly<Record<string, string>> = {
  'box/client_credentials': 'box-ccg-app',
  'github/client_credentials': 'github-app-registration',
  'microsoft-graph/client_credentials': 'entra-graph-app-only-registration',
  'microsoft-graph/user_delegated': 'entra-graph-delegated-registration',
  'microsoft-teams/client_credentials': 'entra-teams-app-registration',
  'salesforce/client_credentials': 'salesforce-external-client-app',
  'snowflake/snowflake_oauth': 'snowflake-oauth-integration',
};

export function integrationWalkthroughFor(
  catalogKey: string | null | undefined,
  profileId: string | null | undefined,
  registry: ReadonlyMap<string, Walkthrough> = walkthroughs,
): Walkthrough | undefined {
  if (!catalogKey || !profileId) return undefined;
  const id = INTEGRATION_WALKTHROUGHS[`${catalogKey}/${profileId}`];
  return id === undefined ? undefined : registry.get(id);
}
